var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex vh-100",attrs:{"id":"background"}},[_c('div',{style:({ maxWidth: _vm.maxWidth }),attrs:{"id":"layout-center"}},[_vm._t("default"),_c('component-toast-container')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }